import React, { useMemo, memo } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import { useLang } from '@/i18n';
import EcoTabsImgSwiper, { EcoTabsImgSwiperItem } from 'eco-design/sections-test/eco-tabs-img-swiper';
import css from './index.module.scss';

const SectionG: React.FC<any> = ({}) => {
    const { t } = useLang('theProduct.SectionG');

    const items: EcoTabsImgSwiperItem[] = useMemo(
        () => [
            {
                tabLabel: t('tab1_title'),
                tabValue: '1',
                description: t('tab1_desc'),
                tabImg: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1760782194002/sectionG_item_1.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1760782194002/sectionG_item_1.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1760782194002/sectionG_item_1.jpg',
                },
                mainImg: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1761633705338/sectiong_1.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1761633704335/sectiong_1_h5.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1761633704335/sectiong_1_h5.jpg',
                    isOpenLazy: true,
                },
                tipLeftTitle: t('tab1_tip_left'),
                tipRightTitle: t('tab1_tip_right'),
                tipTheme: 'black',
            },
            {
                tabLabel: t('tab2_title'),
                tabValue: '2',
                description: t('tab2_desc'),
                tabTip: t('tab2_tip'),
                isVideo: true,
                tabImg: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1760782193762/sectionG_item_2.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1760782193762/sectionG_item_2.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1760782193762/sectionG_item_2.jpg',
                },
                mainImg: {
                    pc: 'https://websiteoss.ecoflow.com/upload/video/1761636820306/sectiong-video.mp4',
                    pad: 'https://websiteoss.ecoflow.com/upload/video/1761636820306/sectiong-video.mp4',
                    h5: 'https://websiteoss.ecoflow.com/upload/video/1761636820306/sectiong-video.mp4',
                    poster: 'https://websiteoss.ecoflow.com/upload/image/1761637810761/sectiong_2.jpg',
                    posterH5: 'https://websiteoss.ecoflow.com/upload/image/1761637978359/sectiong_2_h5.jpg',
                },
                tipLeftTitle: t('tab2_tip_left'),
                tipRightTitle: t('tab2_tip_right'),
                tipTheme: 'white',
            },
            {
                tabLabel: t('tab3_title'),
                tabValue: '3',
                description: t('tab3_desc'),
                tabTip: t('tab3_tip'),
                tabImg: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1760782193989/sectionG_item_3.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1760782193989/sectionG_item_3.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1760782193989/sectionG_item_3.jpg',
                },
                mainImg: {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1762151862166/sectiong_3.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1761633705331/sectiong_3_h5.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1761633705331/sectiong_3_h5.jpg',
                    isOpenLazy: true,
                },
                tipLeftTitle: t('tab3_tip_left'),
                tipRightTitle: t('tab3_tip_right'),
                tipTheme: 'white',
            },
        ],
        [t],
    );

    return (
        <div className={`${css.SectionG} eco-content GtmModuleData-section`} data-section-id="on-the-road-SectionG">
            <EcoSpace />
            <EcoTabsImgSwiper
                title={t.rich('title', {
                    text: (v: string) => <span className="title-font">{v}</span>,
                })}
                subtitle={t('desc')}
                items={items}
            />
        </div>
    );
};

export default memo(SectionG);
